import React, { useEffect } from "react";

import styled from "styled-components";
import { Container, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

import { P3 } from "../../../components/theme/text/Headings";

import { Blue, Black, Purple } from "../../../components/theme/colors";
import { Button } from "../../../components/theme/Button";
import { useNavigate } from "react-router-dom";

import LayoutOnboarding from "../../../components/layout/layoutOnboarding";
import mixpanelService from "../../../services/MixpanelService";
import postHogService from "../../../services/PostHogService";

import logoImg from "../../../images/logo/v.png";

const PageWrapper = styled.div`
  position: relative;
  min-height: 100vh;
  width: 100%;
`;

const Background = styled.div`
  position: absolute;
  background: linear-gradient(120deg, ${Purple}, ${Blue});
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  overflow: hidden;
`;

const ContentWrapper = styled.div`
  position: relative;
  z-index: 2;
  min-height: 100vh;
`;

const TopContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 25vh;
`;

const BottomLogin = styled.div`
  position: absolute;
  bottom: 100px;
  left: 2vh;
  right: 2vh;
`;

const LogoCircle = styled.div`
  width: 175px;
  height: 175px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${Black};
`;

const OnboardingStart = () => {
  const navigate = useNavigate();

  // Track page view on mount
  useEffect(() => {
    const props = {
      step: "start",
      timestamp: new Date().toISOString(),
    };
    mixpanelService.track("Onboarding Start Viewed", props);
    postHogService.track("Onboarding Start Viewed", props);
  }, []);

  const handleUpdateProfile = async () => {
    navigate("/onboarding-intro");
  };

  return (
    <PageWrapper>
      <Background />

      <ContentWrapper>
        <LayoutOnboarding $background="transparent">
          <Container>
            <Row>
              <Col
                lg={{ offset: 4, span: 4 }}
                md={{ offset: 3, span: 6 }}
                sm={{ offset: 2, span: 8 }}
                xs={{ span: 12 }}
                className="text-align-center"
              >
                <TopContent>
                  <LogoCircle>
                    <img
                      src={logoImg}
                      alt="Vibe Check Logo"
                      style={{ height: "150px" }}
                    />
                  </LogoCircle>
                </TopContent>
                <BottomLogin>
                  <div style={{ padding: "0 15px" }}>
                    <Button
                      width="100%"
                      className="mt-20"
                      $background={Black}
                      onClick={handleUpdateProfile}
                    >
                      Create account
                    </Button>
                    <P3 color={Black} className="mt-15">
                      By clicking "Create account", you agree to our{" "}
                      <a
                        href="https://www.vibecheckme.com/terms-of-service"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          color: Black,
                        }}
                      >
                        Terms of Service
                      </a>{" "}
                      <br />
                      and{" "}
                      <a
                        href="https://www.vibecheckme.com/privacy-policy"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          color: Black,
                        }}
                      >
                        Privacy Policy
                      </a>
                      .
                    </P3>
                  </div>
                </BottomLogin>
              </Col>
            </Row>
          </Container>
        </LayoutOnboarding>
      </ContentWrapper>
    </PageWrapper>
  );
};

export default OnboardingStart;
